export default "__VITE_ASSET__64953ad1__"